// File: src/pages/subcategory/InvoiceGenerator.jsx
import React, { useEffect, useRef, useState } from "react";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import LatestInvoice from "./LastestInvoice";
// import LatestInvoiceMobile from "./LatestInvoiceMobile";
import { VeiwLedgerBalance } from "../import/ApiEndPoint/ApiCalling";

const InvoiceGenerator = (props) => {
  const [printView, setPrintView] = useState({});
  const [allCharges, setAllCharges] = useState({});
  const [details, setDetails] = useState([]);
  const [collectedData, setCollectedData] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const pdfOpenedRef = useRef(false);

  const isMobileDevice = () =>
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const openPDFInNewTab = async () => {
    if (pdfOpenedRef.current) return; // avoid multiple opens
    try {
      const blob = await pdf(
        <LatestInvoice
          invoiceData={printView}
          CollectedData={collectedData}
          BilData={props}
          tableList={details}
          AllCharges={allCharges}
        />
      ).toBlob();

      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
      pdfOpenedRef.current = true;

      // cleanup blob after a short delay
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    } catch (err) {
      console.error("Failed to open PDF:", err);
    }
  };

  useEffect(() => {
    let isMounted = true;

    setIsMobile(isMobileDevice());

    const fetchLedgerAndBalances = async (partyId) => {
      try {
        const res = await VeiwLedgerBalance(partyId);
        const ledger = res?.Ledger || [];
        let totalDebit = 0;
        let totalCredit = 0;

        ledger.forEach((entry) => {
          if (entry?.credit) totalCredit += Number(entry.credit) || 0;
          else totalDebit += Number(entry.debit) || 0;
        });

        const openingBalance =
          Number(props?.PrintData?.partyId?.OpeningBalance) || 0;
        const openingType = String(
          props?.PrintData?.partyId?.Type || ""
        ).toLowerCase();

        if (openingType === "debit") totalDebit += openingBalance;
        if (openingType === "credit") totalCredit += openingBalance;

        const difference = totalDebit - totalCredit;

        if (isMounted) {
          setCollectedData({
            creditBalance: totalCredit.toFixed(2),
            debitBalance: totalDebit.toFixed(2),
            closingBalance: difference.toFixed(2),
          });
        }
        return ledger;
      } catch (err) {
        console.error("❌ Error fetching ledger:", err);
        if (isMounted) {
          setCollectedData({
            creditBalance: "0.00",
            debitBalance: "0.00",
            closingBalance: "0.00",
          });
        }
        return [];
      }
    };

    const init = async () => {
      try {
        const userData = JSON.parse(
          localStorage.getItem("Companydetail") || "{}"
        );

        if (props?.PrintData) {
          const prefix = userData?.Prefix || "";
          const suffix = userData?.Suffix || "";
          const rawInvoiceId = props?.PrintData?.invoiceId || "";
          const updatedInvoiceId = `${prefix}${rawInvoiceId}${suffix}`;

          const updatedPrintData = {
            ...props.PrintData,
            invoiceId: updatedInvoiceId,
          };

          // partyId can be at PrintData.partyId or PrintData.order.partyId
          const partyId =
            updatedPrintData?.partyId?._id ||
            updatedPrintData?.order?.partyId?._id ||
            null;

          if (partyId) {
            await fetchLedgerAndBalances(partyId);
          }

          if (isMounted) {
            setPrintView(updatedPrintData);
            setAllCharges(props?.AllCharges || {});
            setDetails(props?.details || []);
          }
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    init();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Mobile: auto-open PDF in new tab
  useEffect(() => {
    if (isMobile && !loading && !pdfOpenedRef.current) {
      openPDFInNewTab();
    }
  }, [isMobile, loading]);

  if (loading) return <div>Loading invoice...</div>;
  if (isMobile) return <div>Opening invoice in new tab...</div>;

  return (
    <div>
      {printView && printView.invoiceId ? (
        <PDFViewer width="1000" height="800">
          {/* Desktop viewer */}
          <LatestInvoice
            invoiceData={printView}
            CollectedData={collectedData}
            BilData={props}
            tableList={details}
            AllCharges={allCharges}
            fileName={`invoice_${props?.PrintData?.invoiceId || "NA"}.pdf`}
          />
        </PDFViewer>
      ) : (
        <div>No invoice data available</div>
      )}
    </div>
  );
};

export default InvoiceGenerator;
